const documentTitleStore = document.title
const documentTitleOnBlur = 'Come back! We miss you' // Define your custom title here

const title = document.querySelector('.js-page-title')

if (title) {
    // Set original title if user is on the site
    window.addEventListener('focus', () => {
        document.title = documentTitleStore
    })

    // If user leaves tab, set the alternative title
    window.addEventListener('blur', () => {
        document.title = title.textContent.trim()
    })
}
